export default function ValidFileDirective() {
	return {
		require: 'ngModel',
		link: function(scope, el, attrs, ngModel) {
			//change event is fired when file is selected
			el.bind('change', () => {
				scope.$apply(() => {
					ngModel.$setViewValue(el.val());
					ngModel.$render();
				});
			});
		}
	};
}
